import React from 'react';
import { TouchableOpacity, Text, View, StyleSheet } from 'react-native';
import { Svg, Path } from 'react-native-svg';

export interface SelectableChipProps {
  label: string;
  isSelected: boolean;
  onPress: () => void;
  showIcon?: boolean;
}

export function SelectableChip({ label, isSelected, onPress, showIcon = true }: SelectableChipProps) {
  return (
    <TouchableOpacity
      style={[
        styles.chip,
        isSelected ? styles.chipSelected : styles.chipUnselected
      ]}
      onPress={onPress}
      activeOpacity={0.7}
    >
      {showIcon && (
        <View style={styles.icon}>
          {isSelected ? (
            <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <Path 
                d="M12.6673 4.2915L6.25065 10.7082L3.33398 7.7915" 
                stroke="#015480" 
                strokeWidth="1.5" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
              />
            </Svg>
          ) : (
            <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <Path 
                d="M4 8H12" 
                stroke="#151515" 
                strokeWidth="1.5" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
              />
              <Path 
                d="M8 4V12" 
                stroke="#151515" 
                strokeWidth="1.5" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
              />
            </Svg>
          )}
        </View>
      )}
      <Text style={[
        styles.text,
        isSelected ? styles.textSelected : styles.textUnselected
      ]}>
        {label}
      </Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  chip: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    paddingVertical: 10,
    paddingHorizontal: 14,
    borderRadius: 17,
    borderWidth: 1,
  },
  chipSelected: {
    backgroundColor: '#E6EBF0',
    borderColor: '#015480',
  },
  chipUnselected: {
    backgroundColor: '#FFFFFF',
    borderColor: '#E7EAED',
  },
  icon: {
    width: 16,
    height: 16,
  },
  text: {
    fontFamily: 'Inter_500Medium',
    fontSize: 12,
    lineHeight: 16.8,
  },
  textSelected: {
    color: '#015480',
  },
  textUnselected: {
    color: '#151515',
  },
});
